module.exports = __webpack_public_path__ + "static/assets/bf38d6c8f8b97d8d5fb7a0bbb2d3dc9a.png";